import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useParams, useSearchParams, ScrollRestoration, useLocation, useNavigate } from 'react-router-dom';
// Config
import { POSTER_SIZE, BACKDROP_SIZE, IMAGE_BASE_URL, CURRENTPAYSLIPS_URL } from '../config';
import API from '../API'
// Components
import Header from './Header';
import Thumb from './Thumb';
import Knoppie from './Knoppie';
import InfoButton from './InfoButton'
import ClubHeader from './ClubHeader';
import SearchBar from './SearchBar';
import ButtonGrid from './ButtonGrid'
import List from './List'
import Tooltip from './Tooltip'
// Hook
import axios from 'axios';
import useAuth from '../hooks/useAuth';
import { useEmployeeListFetch } from '../hooks/useEmployeeList';
import { useCurrentPayrunListFetch } from '../hooks/useCurrentPayrunListFetch';
import { useTimeAttendanceListFetch } from '../hooks/useTimeAttendanceListFetch';
import { usePayTypesListFetch } from '../hooks/usePayTypesListFetch';
import { usePayratesListFetch } from '../hooks/usePayratesListFetch';
// Image
import NoImage from '../images/no-image.png';
import Grid from './Grid';


let renderCount = 0

const PayrunList = () => {
  const auth = useAuth();
  const { playerid } = useParams()
  const location = useLocation();
  const navigate = useNavigate()
  const from = location.state?.from || './'
  console.log(playerid)
  const didInit = useRef(false)
  const [includeSwitch, setIncludeSwitch] = useState(false)
  const [errMessage, setErrMessage] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();



  const [startDate, setStartDate] = useState(() => {
    return localStorage.getItem('startDate') || '';
  });
  const [endDate, setEndDate] = useState(() => {
    return localStorage.getItem('endDate') || '';
  });
  const { state, error, setSearchValue, setIncludeInactive, setTrigger } = useEmployeeListFetch(playerid);
  const { currentPayrunliststate, currentPayrunlistloading, currentPayrunlisterror, currentPayrunlistsearchValue, currentPayrunlistSetSearchValue, setcurrentPayrunlistIncludeInactive, fetchCurrentPayrunlists, setcurrentPayrunlistTrigger } = useCurrentPayrunListFetch()
  const { timeAttendancestate, timeAttendanceloading, timeAttendanceerror, timeAttendancesearchValue, timeAttendancesetLoading, timeAttendancesetSearchValue, timeAttendancesetIncludeInactive, fetchTimeAttendanceList } = useTimeAttendanceListFetch(startDate, endDate);
  const { paytypestate, paytypeloading, paytypeerror, paytypesearchValue, paytypesetSearchValue, paytypesetIncludeInactive, fetchPayTypesList } = usePayTypesListFetch();
  const { payratestate, payrateloading, payrateerror, payratesearchValue, payratesetSearchValue, payratesetIncludeInactive, fetchPayratesList } = usePayratesListFetch();
  const [loading, setLoading] = useState(false)
  const [payslips, setPayslips] = useState([])
  const [grosspay, setGrosspay] = useState(0)
  const [netpay, setNetpay] = useState(0)
  const [tax, setTax] = useState(0)
  const [uif, setUIF] = useState(0)

  const prevSortedListRef = useRef([]);
  function deepEqual(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  const accessToken = auth.auth.accessToken


  useEffect(() => {
    if (startDate) localStorage.setItem('startDate', startDate);
    if (endDate) localStorage.setItem('endDate', endDate);
  }, [startDate, endDate]);


  const { sortedList, datesList } = useMemo(() => {
    const employeeClockIns = {};
    const dateSet = new Set();

    timeAttendancestate.timeAttendances.forEach(record => {
      const employeeId = record.employee?._id;
      const employeeName = record.employee?.givname;
      const employeeSurname = record.employee?.surname;
      const recordDate = new Date(record.date).toISOString().split("T")[0];

      const clockIn = record.clockInTime ? new Date(record.clockInTime) : null;
      const clockOut = record.clockOutTime ? new Date(record.clockOutTime) : null;

      const normalhours = record.paytype?.factor === 1 && clockIn && clockOut ? ((clockOut - clockIn) / (1000 * 60 * 60)).toFixed(2) : "N/A";
      const overtime15 = record.paytype?.factor === 1.5 && clockIn && clockOut ? ((clockOut - clockIn) / (1000 * 60 * 60)).toFixed(2) : "N/A";
      const overtime175 = record.paytype?.factor === 1.75 && clockIn && clockOut ? ((clockOut - clockIn) / (1000 * 60 * 60)).toFixed(2) : "N/A";
      const overtime2 = record.paytype?.factor === 2.0 && clockIn && clockOut ? ((clockOut - clockIn) / (1000 * 60 * 60)).toFixed(2) : "N/A";
      const hours = clockIn && clockOut ? ((clockOut - clockIn) / (1000 * 60 * 60)).toFixed(2) : "N/A";

      dateSet.add(recordDate);

      if (!employeeClockIns[employeeId]) {
        employeeClockIns[employeeId] = {
          employeeid: employeeId,
          name: employeeName,
          surname: employeeSurname,
          totalhours: 0,
          overtime15: 0,
          overtime175: 0,
          overtime2: 0,
          attendance: [],
        };
      }

      employeeClockIns[employeeId].totalhours += normalhours !== "N/A" ? Number(normalhours) : 0;
      employeeClockIns[employeeId].overtime15 += overtime15 !== "N/A" ? Number(overtime15) : 0;
      employeeClockIns[employeeId].overtime175 += overtime175 !== "N/A" ? Number(overtime175) : 0;
      employeeClockIns[employeeId].overtime2 += overtime2 !== "N/A" ? Number(overtime2) : 0;
      employeeClockIns[employeeId].attendance.push({ _id: record._id, ...record, hours });
    });

    return {
      sortedList: Object.values(employeeClockIns).sort((a, b) => (a.surname || "").localeCompare(b.surname || "")),
      datesList: [...dateSet].sort(),
    };
  }, [timeAttendancestate.timeAttendances]);


  useEffect(() => {
    if (!deepEqual(prevSortedListRef.current, sortedList)) {
      prevSortedListRef.current = sortedList;
      if (!paytypeloading && paytypestate?.paytypes?.length > 0 && state?.employees?.length > 0) {
        // Now it's safe to use paytypestate
        compareDataandUpdate("sortedList");
      }
    }
  }, [sortedList]);

  const handleScroll = () => {
    const element = document.getElementById(playerid ? playerid : "")
    console.log("handlescroll is getrigger")
    console.log(element)
    if (element) {
      element.scrollIntoView({

      })

    }

  }

  const compareDataandUpdate = async (trigger) => {

    if (paytypeloading || paytypestate?.paytypes?.length === 0 || state?.employees?.length === 0) {

      return
    }

    console.warn("Compare was nou getrigger deur " + trigger + " " + new Date())

    setLoading(true)

    console.log(payslips)
    console.log(sortedList)

    console.log("Employee IDs from payslipdata:", payslips.map(p => p.employee._id.toString()));
    console.log("Employee IDs from sortedList:", sortedList.map(s => s.employeeid.toString()));

    console.log(paytypestate)
    const normcode = paytypestate.paytypes.find(val => val.code === "NORM")?._id
    const overtime15code = paytypestate.paytypes.find(val => val.code === "OVE1")?._id

    console.log(normcode)
    console.log(overtime15code)

    const combinedList = sortedList.reduce((acc, curr) => {
      const obj = currentPayrunliststate.currentPayslips.find(val => val.employee._id.toString() === curr.employeeid)

      console.log(state)
      const employee = state.employees.find(val => val._id === curr.employeeid);
      const employeebaserate = employee?.baserate;
      const matchingPayrate = payratestate.payrates.find(val => val.code === employeebaserate);


      if (obj) {

        const normPaytype = obj.paytypes.find(val => val.paytype?._id === normcode)
        const overtime15 = obj.paytypes.find(val => val.paytype?._id === overtime15code)

        if (normPaytype) {
          if (employee.dept === "FARW") {
            normPaytype.normalHours = curr.totalhours

          }
        }
        if (overtime15) {
          overtime15.normalHours = curr.overtime15
        } else {
          obj.paytypes.push({
            paytype: overtime15code,
            normalHours: curr.overtime15,
            payrate: payratestate.payrates.find(val => val.code === employeebaserate)?._id

          })
        }
        acc.push(obj)
      } else {





        if (!matchingPayrate) {
          console.warn(`⚠️ No matching payrate found for employee: ${employee?.name} (base rate: ${employeebaserate})`);
        }
        const obj = {
          employee: curr.employeeid,
          date: new Date(),
          paytypes: [
            {
              paytype: normcode,
              normalHours: curr.totalhours,
              payrate: payratestate.payrates.find(val => val.code === employeebaserate)?._id
            },
            {
              paytype: overtime15code,
              normalHours: curr.overtime15,
              payrate: payratestate.payrates.find(val => val.code === employeebaserate)?._id
            }
          ]
        }
        acc.push(obj)
      }

      return acc
    }, [])

    // ✅ Now include any payslipdata not already in combinedList
    const existingEmployeeIds = new Set(combinedList.map(item => item.employee))

    payslips.forEach(item => {

      if (item.employee.dept !== "FARW") { console.log(item.employee.givname) }
      if (!existingEmployeeIds.has(item.employee) && item.employee.dept !== "FARW") {
        combinedList.push(item)
      }
    })

    console.log("SortedList Inside Compate", sortedList)

    console.log("currentpayslips inside Compare", currentPayrunliststate.currentPayslips)

    console.log("Payslips inside Compare", payslips)

    console.log("Combined List inside Compare", combinedList)

    try {

      const response = await axios.post(`${CURRENTPAYSLIPS_URL}/upsert`,
        JSON.stringify({ data: combinedList }),
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + accessToken

          }
        }
      );


    } catch (error) {

      if (!error.response) {
        setErrMessage("No server response")
      } else if (error.response?.status === 400) {
        setErrMessage("Missing data")
      } else if (error.response?.status === 500) {

        setErrMessage(error.response?.data.msg.message)
      } else {
        setErrMessage('failed')
      }
      console.log(error)
    }
    setLoading(false)
    setcurrentPayrunlistTrigger(prev => !prev);

  }

  const loadCurrentPayslips = async () => {

    setLoading(true)

    if (!state || !state.employees || state.employees.length === 0) {
      console.log('Employees not loaded yet.');
      setLoading(false)
      return; // Or show a loading spinner/message
    }



    const payslipdata = state.employees.reduce((acc, curr) => {

      if (curr.standardPayslip.paytypes.length !== 0) {
        acc.push({ employee: curr._id, date: new Date(), ...curr.standardPayslip })
      }
      return acc

    }, [])

    console.log("Employee IDs from payslipdata:", payslipdata.map(p => p.employee.toString()));
    console.log("Employee IDs from sortedList:", sortedList.map(s => s.employeeid.toString()));

    console.log(paytypestate)
    const normcode = paytypestate.paytypes.find(val => val.code === "NORM")?._id
    const overtime15code = paytypestate.paytypes.find(val => val.code === "OVE1")?._id
    console.log(normcode)



    const combinedList = sortedList.reduce((acc, curr) => {
      console.log(state)
      const employee = state.employees.find(val => val._id === curr.employeeid);
      const employeebaserate = employee?.baserate;
      const matchingPayrate = payratestate.payrates.find(val => val.code === employeebaserate);


      const obj = payslipdata.find(val => val.employee === curr.employeeid)

      if (obj) {
        const normPaytype = obj.paytypes.find(val => val.paytype === normcode)
        const overtime15 = obj.paytypes.find(val => val.paytype?._id === overtime15code)
        if (normPaytype) {
          if (employee.dept === "FARW") {
            normPaytype.normalHours = curr.totalhours

          }
        }
        if (overtime15) {
          overtime15.normalHours = curr.overtime15
        } else {
          obj.paytypes.push({
            paytype: overtime15code,
            normalHours: curr.overtime15,
            payrate: payratestate.payrates.find(val => val.code === employeebaserate)?._id

          })
        }
        acc.push(obj)
      } else {





        if (!matchingPayrate) {
          console.warn(`⚠️ No matching payrate found for employee: ${employee?.name} (base rate: ${employeebaserate})`);
        }
        const obj = {
          employee: curr.employeeid,
          date: new Date(),
          paytypes: [
            {
              paytype: normcode,
              normalHours: curr.totalhours,
              payrate: payratestate.payrates.find(val => val.code === employeebaserate)?._id
            },
            {
              paytype: overtime15code,
              normalHours: curr.overtime15,
              payrate: payratestate.payrates.find(val => val.code === employeebaserate)?._id
            }
          ]
        }
        acc.push(obj)
      }

      return acc
    }, [])

    // ✅ Now include any payslipdata not already in combinedList
    const existingEmployeeIds = new Set(combinedList.map(item => item.employee))

    payslipdata.forEach(item => {
      if (!existingEmployeeIds.has(item.employee)) {
        combinedList.push(item)
      }
    })

    console.log(sortedList)


    console.log(payslipdata)

    console.log(combinedList)

    try {

      const response = await axios.post(`${CURRENTPAYSLIPS_URL}/upsert`,
        JSON.stringify({ data: combinedList }),
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + accessToken

          }
        }
      );


    } catch (error) {

      if (!error.response) {
        setErrMessage("No server response")
      } else if (error.response?.status === 400) {
        setErrMessage("Missing data")
      } else if (error.response?.status === 500) {

        setErrMessage(error.response?.data.msg.message)
      } else {
        setErrMessage('failed')
      }
      console.log(error)
    }
    setLoading(false)
    setcurrentPayrunlistTrigger(prev => !prev);

  }

  const test = async () => {
    const employee = state[0]

    console.log(state)
    const employeebaserate = state.employees.find(val => val._id === "636e10879b0c859c8b97d6a1")?.baserate
    console.log(payratestate.payrates.find(val => val.code === employeebaserate)?._id)


  }


  const deleteCurrentPayslip = async (e) => {
    console.log("gekliek op" + e.target.id)
    console.log(auth.auth.user.username)

    try {

      // eslint-disable-next-line no-restricted-globals
      const confirmation = confirm("Are you sure you want to Delete this payslip? This action cannot be overturned!")
      if (confirmation) {

        console.log("Sukses, die employee gaan delete word hier")
        await API.deleteCurrentPayslip(e.target.id, auth.auth.accessToken)

      } else {
        return
      }

      setcurrentPayrunlistTrigger(prev => !prev);

    } catch (error) {
      console.log(error)
    }



  }

  const deleteAllPayslips = async (e) => {

    console.log(auth.auth.user.username)

    try {

      // eslint-disable-next-line no-restricted-globals
      const confirmation = confirm("Are you sure you want to Delete all Payslips? This action cannot be overturned!")
      if (confirmation) {

        console.log("Sukses, die employee gaan delete word hier")
        await API.deleteAllPayslips(auth.auth.accessToken)

      } else {
        return
      }

      setcurrentPayrunlistTrigger(prev => !prev);

    } catch (error) {
      console.log(error)
    }



  }

  useEffect(() => {

    if (!loading) {
      handleScroll()
    }

  }, [currentPayrunliststate])

  // Om die totals te bereken wanneer state verander
  useEffect(() => {
    console.log("die update Payslips useEffect is getrigger");

    const updatePayslips = async () => {
      const updatedPayslips = await Promise.all(
        currentPayrunliststate.currentPayslips.map(async (payslip) => {
          // Use an async function inside reduce
          const income = await payslip.paytypes.reduce(async (accPromise, curr) => {
            const acc = await accPromise; // Ensure previous value is awaited
            let rate = curr.payrate?.rate || 0;
            let factor = curr.paytype?.factor || 1;
            let hours = curr.normalHours || 0;
            return acc + rate * factor * hours;
          }, Promise.resolve(0)); // Start with resolved promise

          const additions = payslip.additions.reduce((acc, curr) => {
            let amount = curr?.amount || 0;
            return acc + amount;
          }, 0).toFixed(2);

          const deductions = payslip.deductions.reduce((acc, curr) => {
            let amount = curr?.amount || 0;
            return acc + amount;
          }, 0).toFixed(2);

          const calculateTax = () => {

            var tax = 0
            var grosspay = (Number(income) + Number(additions) - Number(deductions))

            if (grosspay * 12 < 95750) {
              tax = 0
            } else if (grosspay * 12 < 237100) {
              tax = ((grosspay * 12 * .18) - 17235) / 12
            } else if (grosspay * 12 < 370500) {
              tax = (((grosspay * 12 - 237100) * .26) + 42678 - 17235) / 12
            } else if (grosspay * 12 < 512800) {
              tax = (((grosspay * 12 - 370500) * .31) + 77362 - 17235) / 12
            } else if (grosspay * 12 < 673000) {
              tax = (((grosspay * 12 - 512800) * .36) + 121475 - 17235) / 12
            } else if (grosspay * 12 < 857900) {
              tax = (((grosspay * 12 - 673000) * .39) + 179147 - 17235) / 12
            } else if (grosspay * 12 < 1817000) {
              tax = (((grosspay * 12 - 857900) * .41) + 251258 - 17235) / 12
            } else if (grosspay * 12 > 1817000) {
              tax = (((grosspay * 12 - 1817000) * .45) + 644489 - 17235) / 12
            }

            var uif = 0
            if (grosspay * 0.01 < 177.12) {
              uif = grosspay * 0.01
            } else {
              uif = 177.12
            }

            return { tax: tax.toFixed(2), uif: uif.toFixed(2) }

          }

          const netpay = Number(income) + Number(additions) - Number(deductions) - Number(calculateTax().tax) - Number(calculateTax().uif)

          return { ...payslip, income, tax: calculateTax().tax, uif: calculateTax().uif, netpay };
        })
      );


      const totalgrosspay = updatedPayslips.reduce((acc, curr) => {
        return acc + Number(curr.income)
      }, 0)
      const totalnetpay = updatedPayslips.reduce((acc, curr) => {
        return acc + Number(curr.netpay)
      }, 0)
      const totaltax = updatedPayslips.reduce((acc, curr) => {
        return acc + Number(curr.tax)
      }, 0)
      const totaluif = updatedPayslips.reduce((acc, curr) => {
        return acc + Number(curr.uif)
      }, 0)


      setGrosspay(totalgrosspay)
      setNetpay(totalnetpay)
      setTax(totaltax)
      setUIF(totaluif)
      setLoading(false)
      setPayslips(updatedPayslips);
      console.log(updatedPayslips)
    };

    updatePayslips(); // Call the async function

  }, [currentPayrunliststate]);



  const username = auth.auth.user.username

  const access = auth.auth.user.userRole
  // console.log(besluit.besluit[0].besluit)
  console.log(state)
  console.log(currentPayrunliststate)

  renderCount++
  return (
    <>

      <Header username={username} role={access} destination={from}></Header>


      <div>Payslip Summary</div>
      <div className='SummaryLine'>
        <div className='PayslipText'>Total Gross Salary</div>
        <div className='PayslipNumbers'>{grosspay.toFixed(2)}</div>
      </div>
      <div className='SummaryLine'>
        <div className='PayslipText'>Total Net Salary</div>
        <div className='PayslipNumbers'>{netpay.toFixed(2)}</div>
      </div>
      <div className='SummaryLine'>
        <div className='PayslipText'>Total Tax</div>
        <div className='PayslipNumbers'>{tax.toFixed(2)}</div>
      </div>
      <div className='SummaryLine'>
        <div className='PayslipText'>Total UIF</div>
        <div className='PayslipNumbers'>{uif.toFixed(2)}</div>
      </div>
      {/* <h1>RenderCount {renderCount/2}</h1> */}

      <div className='ListHead'>
        <SearchBar key={1} setSearchValue={setSearchValue}></SearchBar>

        
        <ButtonGrid>
          <div className='checkLineitem'>
          <div>Date range for hourly wages and overtime</div>

          <div className='checkLineitem'>

            <Tooltip message='Please note that your payslips will change back to 
              clocking data if you change the dates. Manually changes to payslips will be lost'>

              <input
                type='date'
                value={startDate instanceof Date &&
                  !isNaN(startDate) ? startDate.toISOString().split('T')[0] :
                  startDate}
                onChange={(e) => setStartDate(e.target.value)}

              />
            </Tooltip>
            to
            <input
              type='date'
              value={endDate instanceof Date &&
                !isNaN(endDate) ? endDate.toISOString().split('T')[0] :
                endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>

        </div>
        <Knoppie
          clickable={true}
          text={"Show Attendance list"}
          from={'./PayrunList'}
          destination={"../TimeAttendanceList"}

        />

</ButtonGrid>
<ButtonGrid>
          <Knoppie
            clickable={true}
            text={"Add a Payslip"}
            destination={'../CurrentPayslip/newid'}
          />
          <Knoppie
            clickable={true}
            text={"Delete All current payslips"}
            callback={() => { deleteAllPayslips() }}
          />
          <Knoppie
            clickable={true}
            text={"Refresh Clock data."}
            callback={() => { compareDataandUpdate() }}
          />

        </ButtonGrid>
      </div>

      {loading ? "...Loading" : ""}
      {error ? "error" : ""}
      <div>{`Payslips ${currentPayrunliststate.currentPayslips.length}`}</div>


      {currentPayrunliststate.currentPayslips.length === 0 &&

        <Knoppie
          text={"Load from standardPayslips"}
          callback={() => { loadCurrentPayslips() }}
        />

      }
      <div className='currentPayslipLineitem Heading'>
        <div className='currentPayslipLinedata'>
          <div>Name</div>
          <div>date</div>
          <div className='PayslipNumbers'>Income</div>
          <div className='PayslipNumbers'>Netpay</div>
        </div>
        <Knoppie text={'Actions'} />


      </div>

      {payslips.map((payslip) => {


        return (
          <>
            <div className='currentPayslipLineitem'>
              <div
                className='currentPayslipLinedata'
                onClick={() => navigate(`../CurrentPayslip/${payslip._id}`)
                }>

                <div>{payslip.employee?.givname + " " + payslip.employee?.surname}</div>
                <div>{payslip.date ? new Date(payslip.date).toISOString().split('T')[0] : ""}</div>
                <div className='PayslipNumbers' >{payslip.income.toFixed(2)}</div>
                <div className='PayslipNumbers'>{payslip.netpay.toFixed(2)}</div>

              </div>
              <Knoppie
                clickable={true}
                text={'Remove'}
                employeeid={payslip._id}
                callback={deleteCurrentPayslip}
              />
            </div>
          </>
        )

      })}

      {loading ? <h1>...Loading</h1> : ""}






    </>
  );
};

export default PayrunList;

